//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTables', {
//        templateUrl: 'views/components/views/metaTables/metaTables.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'metaTablesService', function (stateService, metaTablesService) {
//            const vm = this;

//            vm.model = {
//                itemsListMetaTables: []
//            };

//            async function loadMetaTables() {
//                vm.model.itemsListMetaTables = await metaTablesService.listMetaTables();
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'metatable':
//                        go({ metatable_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = function () {
//                loadMetaTables();
//            }
//        }]
//    });
//})();
